import { mapGetters, mapActions } from "vuex"
const DescriptionSheet = () => import("@/components/DescriptionSheet/DescriptionSheet.vue")

export default {
  components: {
    DescriptionSheet
  },
  computed: {
    ...mapGetters({
      spinnerSupportBusiness: "isLoading"
    }),
    ...mapGetters('descriptionSheets', {
      descriptionSheets: 'descriptionSheets'
    }),
    ...mapGetters('categories', {
      categories: 'categories'
    }),
    ...mapGetters('mission', {
      missions: 'missions'
    })
  },
  watch: {
    $route(value) {
      if (!value.query.pathologies) {
        this.pathologies = false
        this.getDescriptionSheets()
        this.getCategories()
      }
    },
  },
  data() {
    return {
      pathologies: false,
      search: "",
      searchTitle: "",
      isClickCategory: false,
      clickedCategory: undefined,
      isSearchDescriptionSheet: false
    }
  },
  async created() {
    if ('pathologies' in this.$route.query) {
      this.pathologies = true
      this.getDescriptionSheets({ pathologies: this.$route.query.pathologies })
    } else {
      await this.getMissions()
      await this.getDescriptionSheets({ pathologies: this.missions.length ? this.getPathologies(this.missions) : "" })
      await this.getCategories()
    }
  },
  methods: {
    ...mapActions("descriptionSheets", {
      getDescriptionSheets: "refresh"
    }),
    ...mapActions("categories", {
      getCategories: "refresh"
    }),
    ...mapActions('mission', ['getMissions']),
    getPathologies(missions) {
      let pathologies = [];
      missions.forEach(mission => {
        if (mission.pathologies && mission.pathologies.length) {
          mission.pathologies.forEach(pathology => {
            const { pkPathology } = pathology
            if (!pathologies.includes(pkPathology)) {
              pathologies.push(pkPathology)
            }
          });
        }
      });
      return pathologies.toString();
    },
    resetSearch() {
      this.search = ''
      this.isClickCategory = false
      this.clickedCategory = undefined
      this.isSearchDescriptionSheet = false
    },
    onClickRecommend() {
      if (this.searchTitle || this.clickedCategory) {
        this.getDescriptionSheets({ pathologies: this.missions.length ? this.getPathologies(this.missions) : "" })
      }
      this.resetSearch()
    },
    onClickCategory(category, subCategory = null, subCategory2 = null) {
      this.isClickCategory = true
      this.handleSearch(category, subCategory, subCategory2)
    },
    handleSearch: _.debounce(function (category = null, subCategory = null, subCategory2 = null) {
      if (!this.search && !category && !subCategory && !subCategory2) {
        this.isSearchDescriptionSheet = false
        return;
      }
      this.isSearchDescriptionSheet = true
      if (!category && !subCategory && !subCategory2) {
        this.searchTitle = this.search
        this.clickedCategory = undefined
        this.getDescriptionSheets({ keyword: this.search })
      } else {
        this.searchTitle = ""
        this.clickedCategory = {
          level1: category,
          level2: subCategory,
          level3: subCategory2
        }
        if (subCategory2 && subCategory2.id) {
          this.getDescriptionSheets({ category: subCategory2.id })
        } else if (subCategory && subCategory.id) {
          this.getDescriptionSheets({ category: subCategory.id })
        } else {
          this.getDescriptionSheets({ category: category.id })
        }
      }
    }, 300),
    itemCollapse(categories, index = null, level = null) {
      categories.map((item, i) => {
        if (String(index) || item.expand) {
          item.expand = !item.expand
        }
        if (String(index) && i !== index) {
          item.expand = false
        }
        if (level === "1") {
          item = this.setCollapseItem(item)
        }
        return item
      })
    },
    setCollapseItem(data) {
      data.subCategories.forEach((item) => {
        if (item.expand) {
          item.expand = false
          setCollapseItem(item)
        }
      })
      return data
    },
    backToPrevious() {
      this.$router.go(-1)
    }
  }
}
